import {AppServices} from "../../config/entities";
import {IPostDocumentDto} from "../../dtos/documents/IPostDocumentDto";
import {ICancelDocumentDto} from "../../dtos/documents/ICancelDocumentDto";
import {IPostDocumentResponseDto} from "../../dtos/documents/IPostDocumentResponseDto";
import {format} from "date-fns";
import {IBaseDocumentPagingRequestDto} from "../../dtos/pagination/IBaseDocumentPagingRequestDto";

export class DocumentService {
    constructor(private catalogName: string) {
        this.catalogName = catalogName;
    }

    async GetAll(
        searchText: string | undefined,
        startDate?: Date | undefined,
        endDate?: Date | undefined
    ) {
        let url = this.catalogName;

        let firstParam: boolean = true;

        if (
            searchText !== undefined &&
            searchText !== null &&
            searchText.trim() !== ""
        ) {
            url += `${firstParam ? "?" : "&"}searchText=${searchText}`;
            firstParam = false;
        }

        if (startDate) {
            url += `${firstParam ? "?" : "&"}startDate=${format(
                startDate,
                "yyyy-MM-dd'T'HH:mm:ss"
            )}`;
            firstParam = false;
        }
        if (endDate) {
            url += `${firstParam ? "?" : "&"}endDate=${format(
                endDate,
                "yyyy-MM-dd'T'HH:mm:ss"
            )}`;
            firstParam = false;
        }
        const response = await AppServices.Axios.get(url);
        return response.data;
    }

    async GetPage(request: IBaseDocumentPagingRequestDto) {
        let url = `${this.catalogName}/page`;

        const requestBodyDto = {
            startDate: request.startDate,
            endDate: request.endDate,
            loadOptions: {
                skip: request.loadOptions.skip,
                take: request.loadOptions.take,
                filter: request.loadOptions.filter ?? [],
                sort: request.loadOptions.sort ?? [],
            }
        }

        const response = await AppServices.Axios.post(url, requestBodyDto);
        return response.data;
    }

    async Get(id: string) {
        console.log("Get", id);
        const response = await AppServices.Axios.get(this.catalogName + "/" + id);
        console.log(response.data);
        return response.data;
    }

    async Delete(selectedItemId: string | null) {
        if (selectedItemId) {
            console.log("Delete", selectedItemId);
            const response = await AppServices.Axios.delete(
                this.catalogName + "/" + selectedItemId
            );
            console.log("Delete response", response);
        }
    }

    async Update(model: any) {
        const response = await AppServices.Axios.put(this.catalogName, model);
        if (!response) {
            throw new Error("No response from server or server error!");
        }
        if (response.status !== 200) {
            throw new Error(response.statusText);
        }
        console.log("Update response", response);
        return response.data;
    }

    async Create(model: any) {
        console.log("Create", model);
        const response = await AppServices.Axios.post(this.catalogName, model);
        if (!response) {
            throw new Error("No response from server or server error!");
        }
        if (response.status !== 200) {
            throw new Error(response.statusText);
        }
        console.log("Update response", response);
        console.log("Create response", response);
        return response.data;
    }

    async PostDocument(id: string) {
        const url = `${this.catalogName}/post`;
        const dto: IPostDocumentDto = {id};
        const response = await AppServices.Axios.post(url, {post: dto});
        if (!response) {
            throw new Error("No response from server or server error!");
        }
        if (response.status !== 200) {
            throw new Error(response.statusText);
        }
        const responseDto: IPostDocumentResponseDto = response.data;
        return responseDto;
    }

    async CancelDocument(id: string) {
        console.log("Cancel document", id);
        const url = `${this.catalogName}/cancel`;
        const dto: ICancelDocumentDto = {id};
        const response = await AppServices.Axios.post(url, dto);
        console.log("Cancel document response", response);
        return response.data;
    }
}
